// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-teams-enrollment__nav-container span {
    font-size: calc( var( --space ) + 1px );
    margin-right: var( --space-half );
}

.tournament-teams-enrollment__container{
    position: relative;
}

.tournament-teams-enrollment__nav-container {
    display: flex;
    align-items: center;
    margin: var( --space-and-half ) 0;
}
.tournament-teams-enrollment-tournament__container {
    width: 100%;
    height: 229px;
    overflow: hidden;
    display: flex;
    align-items: center;
    border-radius: 16px 16px 0px 0px;
}

.tournament-teams-enrollment__image__background-img{
    width: 100%;
}

.tournament-teams-enrollment__tabs-content__container {
    height: 100%;
}

.tournament-teams-enrollment__info-tournament__container,
.tournament-teams-enrollment__tabs-content__container {
    background: var( --white-color );
    border-radius: var(  --space-half );
}

.tournament-teams-enrollment__info-tournament__container {
    padding: var( --space ) var( --space-x2 ) var(--space) var(--space);
    border-bottom: 1px solid var( --new-gray-background-color );
}

.tournament-teams-enrollment__info-tournament__container .left-col .icon-ball {
    color: var(--white-color);
    padding: 5px;
    font-size: 35px;
    border-radius: 50%;
    margin-right: var( --space );
}

.tournament-teams-enrollment__info-tournament__container .left-col img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-right: var( --space );
}

.tournament-teams-enrollment__info-tournament__container .left-col .tournament-info.baloa-names {
    color: var( --primary-dark-color );
}

.tournament-teams-enrollment__info-tournament__container .left-col .tournament-info div:last-of-type {
    display: flex;
    align-items: center;
}

.tournament-teams-enrollment__info-tournament__container .left-col {
    display: flex;
    align-items: center;
    width: 100%;
}

.tournament-teams-enrollment__info-tournament__container .right-col {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 200px;
}

.right-col .icon-options {
    cursor: pointer;
}

.tournament-teams-enrollment__info-tournament__container {
    display: flex;
    justify-content: space-between;
}

.tournament-team__button.small{
    position: absolute;
    margin-right: 36px;
    padding: 12px;
    color: var(--primary-dark-color)
}

.tournament-teams-enrollment-tournament-img_container {
    position: absolute;
    width: 100%;
    height: 229px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px 16px 0px 0px;
}

.tournament-teams-enrollment__image{
    border-radius: 16px 16px 0px 0px;
    background: rgba(77, 84, 81, 0.64);
    backdrop-filter: blur(4px);  
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.tournament-teams-enrollment__image .icon-trophy{
    color: var(--white-color);
    font-size: 52px;
    width: 419px;
    height: 229px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-teams-enrollment__image img{
    width: 419px;
    height: 229px;
}

.tournament-info__dates-location {
    display: flex;
    align-items: center;
}

.tournament-info__dates-location:first-of-type {
    margin-right: var( --space );
}

.tournament-info__dates-location .baloa-username {
    color: var( --primary-dark-color );
}

.tournament-info__dates-location span {
    color: var( --primary-dark-color );
    margin-right: var( --space-half );
}

.tournament-teams-enrollment__start-tournament__btn.button {
    padding: var( --space-half ) var( --space );
    font-size: var( --space );
}

.tournament-teams-enrollment__add-member {
    padding: 16px;
}

.tournament-teams-enrollment__add-member .league-addto__container__left,
.tournament-teams-enrollment__add-member .league-addto__container__right {
    border: none;
}

.tournament-teams-enrollment__cancel-tournament {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc( var(--space-x3) + var(--space-quarter) );
    border-radius: var( --space-half );
    background-color: var( --white-color );
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    padding: 0 var( --space-half-quarter );
    cursor: pointer;
}

.tournament-teams-enrollment__cancel-tournament .baloa-table-column {
    color: var( --primary-very-dark-color );
    white-space: nowrap;
    margin-left: var( --space-half );
}

.tournament-teams-enrollment__cancel-tournament .icon-x {
    color: var( --error-color );
    border: var( --error-color  ) 2px solid;
    border-radius: 50%;
}

.tournament-teams-enrollment__tournament-info {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    justify-content: space-between;
    width: 100%;
    padding: 8px 16px;
}

.tournament-teams-enrollment__tournament-info__labels {
    display: flex;
    align-items: center;
    gap: var(--space-half);
}

.tournament-teams-enrollment__label {
    background: var( --primary-dark-color );
    color: var( --white-color );
    border-radius: var( --space-and-half );
    padding: var(--space-quarter) var(--space-half);
}

/* .tournament-teams-enrollment__label:nth-of-type(2) {
    margin: 0 var(--space-half);
} */

.tournament-teams-enrollment__tournament-info__share-btn.small {
    display: flex;
    align-items: center;
    padding: var(--space-half-quarter);
}

.tournament-teams-enrollment__tournament-info__share-btn.small:hover .baloa-table {
    color: var(--white-color);
}

.tournament-teams-enrollment__tournament-info__share-btn .hubicon-share_v2 {
    margin-right: var(--space-half-quarter);
}

.tournament-teams-enrollment__tournament-info__share-btn .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.tournament-teams-enrollment__tournament-info__share-btn.small:focus .baloa-table {
    color: var(--white-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-teams-enrollment/TournamentTeamsEnrollment.styles.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,mEAAmE;IACnE,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;IACtD,kCAAkC;IAClC,sCAAsC;IACtC,iDAAiD;IACjD,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".tournament-teams-enrollment__nav-container span {\n    font-size: calc( var( --space ) + 1px );\n    margin-right: var( --space-half );\n}\n\n.tournament-teams-enrollment__container{\n    position: relative;\n}\n\n.tournament-teams-enrollment__nav-container {\n    display: flex;\n    align-items: center;\n    margin: var( --space-and-half ) 0;\n}\n.tournament-teams-enrollment-tournament__container {\n    width: 100%;\n    height: 229px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    border-radius: 16px 16px 0px 0px;\n}\n\n.tournament-teams-enrollment__image__background-img{\n    width: 100%;\n}\n\n.tournament-teams-enrollment__tabs-content__container {\n    height: 100%;\n}\n\n.tournament-teams-enrollment__info-tournament__container,\n.tournament-teams-enrollment__tabs-content__container {\n    background: var( --white-color );\n    border-radius: var(  --space-half );\n}\n\n.tournament-teams-enrollment__info-tournament__container {\n    padding: var( --space ) var( --space-x2 ) var(--space) var(--space);\n    border-bottom: 1px solid var( --new-gray-background-color );\n}\n\n.tournament-teams-enrollment__info-tournament__container .left-col .icon-ball {\n    color: var(--white-color);\n    padding: 5px;\n    font-size: 35px;\n    border-radius: 50%;\n    margin-right: var( --space );\n}\n\n.tournament-teams-enrollment__info-tournament__container .left-col img {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    margin-right: var( --space );\n}\n\n.tournament-teams-enrollment__info-tournament__container .left-col .tournament-info.baloa-names {\n    color: var( --primary-dark-color );\n}\n\n.tournament-teams-enrollment__info-tournament__container .left-col .tournament-info div:last-of-type {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-teams-enrollment__info-tournament__container .left-col {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.tournament-teams-enrollment__info-tournament__container .right-col {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-width: 200px;\n}\n\n.right-col .icon-options {\n    cursor: pointer;\n}\n\n.tournament-teams-enrollment__info-tournament__container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-team__button.small{\n    position: absolute;\n    margin-right: 36px;\n    padding: 12px;\n    color: var(--primary-dark-color)\n}\n\n.tournament-teams-enrollment-tournament-img_container {\n    position: absolute;\n    width: 100%;\n    height: 229px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px 16px 0px 0px;\n}\n\n.tournament-teams-enrollment__image{\n    border-radius: 16px 16px 0px 0px;\n    background: rgba(77, 84, 81, 0.64);\n    backdrop-filter: blur(4px);  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.tournament-teams-enrollment__image .icon-trophy{\n    color: var(--white-color);\n    font-size: 52px;\n    width: 419px;\n    height: 229px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-teams-enrollment__image img{\n    width: 419px;\n    height: 229px;\n}\n\n.tournament-info__dates-location {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-info__dates-location:first-of-type {\n    margin-right: var( --space );\n}\n\n.tournament-info__dates-location .baloa-username {\n    color: var( --primary-dark-color );\n}\n\n.tournament-info__dates-location span {\n    color: var( --primary-dark-color );\n    margin-right: var( --space-half );\n}\n\n.tournament-teams-enrollment__start-tournament__btn.button {\n    padding: var( --space-half ) var( --space );\n    font-size: var( --space );\n}\n\n.tournament-teams-enrollment__add-member {\n    padding: 16px;\n}\n\n.tournament-teams-enrollment__add-member .league-addto__container__left,\n.tournament-teams-enrollment__add-member .league-addto__container__right {\n    border: none;\n}\n\n.tournament-teams-enrollment__cancel-tournament {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: calc( var(--space-x3) + var(--space-quarter) );\n    border-radius: var( --space-half );\n    background-color: var( --white-color );\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    padding: 0 var( --space-half-quarter );\n    cursor: pointer;\n}\n\n.tournament-teams-enrollment__cancel-tournament .baloa-table-column {\n    color: var( --primary-very-dark-color );\n    white-space: nowrap;\n    margin-left: var( --space-half );\n}\n\n.tournament-teams-enrollment__cancel-tournament .icon-x {\n    color: var( --error-color );\n    border: var( --error-color  ) 2px solid;\n    border-radius: 50%;\n}\n\n.tournament-teams-enrollment__tournament-info {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 0;\n    justify-content: space-between;\n    width: 100%;\n    padding: 8px 16px;\n}\n\n.tournament-teams-enrollment__tournament-info__labels {\n    display: flex;\n    align-items: center;\n    gap: var(--space-half);\n}\n\n.tournament-teams-enrollment__label {\n    background: var( --primary-dark-color );\n    color: var( --white-color );\n    border-radius: var( --space-and-half );\n    padding: var(--space-quarter) var(--space-half);\n}\n\n/* .tournament-teams-enrollment__label:nth-of-type(2) {\n    margin: 0 var(--space-half);\n} */\n\n.tournament-teams-enrollment__tournament-info__share-btn.small {\n    display: flex;\n    align-items: center;\n    padding: var(--space-half-quarter);\n}\n\n.tournament-teams-enrollment__tournament-info__share-btn.small:hover .baloa-table {\n    color: var(--white-color);\n}\n\n.tournament-teams-enrollment__tournament-info__share-btn .hubicon-share_v2 {\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-teams-enrollment__tournament-info__share-btn .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.tournament-teams-enrollment__tournament-info__share-btn.small:focus .baloa-table {\n    color: var(--white-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
